// extracted by mini-css-extract-plugin
export default {"container":"spinner_container__aBsjl","loadingText":"spinner_loadingText__wjJez"};